import tokens from '../tokens/js/tokens';
// Definition of the "brand2" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
export const BRAND2_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.emerald[700].value,
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[400].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Hover
export const BRAND2_LIGHT_HARD_HOVER = {
    background: tokens.colors.emerald[600].value,
    border: tokens.colors.emerald[600].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Pressed
export const BRAND2_LIGHT_HARD_PRESSED = {
    background: tokens.colors.emerald[200].value,
    border: tokens.colors.emerald[200].value,
    foregroundAlt: tokens.colors.emerald[500].value,
    foreground: tokens.colors.emerald[500].value
};
// Light + Hard + Focus
export const BRAND2_LIGHT_HARD_FOCUS = {
    background: tokens.colors.emerald[700].value,
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[400].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Disabled
export const BRAND2_LIGHT_HARD_DISABLED = {
    background: tokens.colors.midnight[300].value,
    border: tokens.colors.midnight[300].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + White + Default
export const BRAND2_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + White + Hover
export const BRAND2_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: tokens.colors.emerald[500].value,
    foregroundAlt: tokens.colors.emerald[500].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + White + Pressed
export const BRAND2_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Light + White + Focus
export const BRAND2_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + White + Disabled
export const BRAND2_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Secondary + Default
export const BRAND2_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + Secondary + Hover
export const BRAND2_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: tokens.colors.emerald[500].value,
    foregroundAlt: tokens.colors.emerald[500].value,
    foreground: tokens.colors.emerald[500].value
};
// Light + Secondary + Pressed
export const BRAND2_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Light + Secondary + Focus
export const BRAND2_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + Secondary + Disabled
export const BRAND2_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Default
export const BRAND2_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + Bare + Hover
export const BRAND2_LIGHT_BARE_HOVER = {
    background: tokens.colors.emerald[150].value,
    border: tokens.colors.emerald[150].value,
    foregroundAlt: tokens.colors.emerald[400].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + Bare + Pressed
export const BRAND2_LIGHT_BARE_PRESSED = {
    background: tokens.colors.emerald[200].value,
    border: tokens.colors.emerald[200].value,
    foregroundAlt: tokens.colors.emerald[400].value,
    foreground: tokens.colors.emerald[400].value
};
// Light + Bare + Focus
export const BRAND2_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Light + Bare + Disabled
export const BRAND2_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: tokens.colors.emerald[100].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
export const BRAND2_DARK_HARD_DEFAULT = {
    background: tokens.colors.emerald[500].value,
    border: tokens.colors.emerald[500].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.black[100].value
};
// Dark + Hard + Hover
export const BRAND2_DARK_HARD_HOVER = {
    background: tokens.colors.emerald[300].value,
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[600].value,
    foreground: tokens.colors.black[100].value
};
// Dark + Hard + Pressed
export const BRAND2_DARK_HARD_PRESSED = {
    background: tokens.colors.emerald[800].value,
    border: tokens.colors.emerald[800].value,
    foregroundAlt: tokens.colors.emerald[600].value,
    foreground: tokens.colors.emerald[600].value
};
// Dark + Hard + Focus
export const BRAND2_DARK_HARD_FOCUS = {
    background: tokens.colors.emerald[500].value,
    border: tokens.colors.emerald[500].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.black[100].value
};
// Dark + Hard + Disabled
export const BRAND2_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + White + Default
export const BRAND2_DARK_WHITE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + White + Hover
export const BRAND2_DARK_WHITE_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[600].value,
    foregroundAlt: tokens.colors.emerald[500].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + White + Pressed
export const BRAND2_DARK_WHITE_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Dark + White + Focus
export const BRAND2_DARK_WHITE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + White + Disabled
export const BRAND2_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Secondary + Default
export const BRAND2_DARK_GHOST_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + Secondary + Hover
export const BRAND2_DARK_GHOST_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[500].value,
    foregroundAlt: tokens.colors.emerald[500].value,
    foreground: tokens.colors.emerald[500].value
};
// Dark + Secondary + Pressed
export const BRAND2_DARK_GHOST_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[700].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[700].value
};
// Dark + Secondary + Focus
export const BRAND2_DARK_GHOST_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + Secondary + Disabled
export const BRAND2_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Bare + Default
export const BRAND2_DARK_BARE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + Bare + Hover
export const BRAND2_DARK_BARE_HOVER = {
    background: tokens.colors.emerald[850].value,
    border: tokens.colors.emerald[850].value,
    foregroundAlt: tokens.colors.emerald[600].value,
    foreground: tokens.colors.emerald[600].value
};
// Dark + Bare + Pressed
export const BRAND2_DARK_BARE_PRESSED = {
    background: tokens.colors.emerald[800].value,
    border: tokens.colors.emerald[800].value,
    foregroundAlt: tokens.colors.emerald[700].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + Bare + Focus
export const BRAND2_DARK_BARE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.emerald[300].value,
    foregroundAlt: tokens.colors.emerald[300].value,
    foreground: tokens.colors.emerald[300].value
};
// Dark + Bare + Disabled
export const BRAND2_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const BRAND2_LIGHT_HARD = {
    default: BRAND2_LIGHT_HARD_DEFAULT,
    disabled: BRAND2_LIGHT_HARD_DISABLED,
    focus: BRAND2_LIGHT_HARD_FOCUS,
    hover: BRAND2_LIGHT_HARD_HOVER,
    pressed: BRAND2_LIGHT_HARD_PRESSED
};
// Light + White
export const BRAND2_LIGHT_WHITE = {
    default: BRAND2_LIGHT_WHITE_DEFAULT,
    disabled: BRAND2_LIGHT_WHITE_DISABLED,
    focus: BRAND2_LIGHT_WHITE_FOCUS,
    hover: BRAND2_LIGHT_WHITE_HOVER,
    pressed: BRAND2_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const BRAND2_LIGHT_GHOST = {
    default: BRAND2_LIGHT_GHOST_DEFAULT,
    disabled: BRAND2_LIGHT_GHOST_DISABLED,
    focus: BRAND2_LIGHT_GHOST_FOCUS,
    hover: BRAND2_LIGHT_GHOST_HOVER,
    pressed: BRAND2_LIGHT_GHOST_PRESSED
};
// Light + Bare
export const BRAND2_LIGHT_BARE = {
    default: BRAND2_LIGHT_BARE_DEFAULT,
    disabled: BRAND2_LIGHT_BARE_DISABLED,
    focus: BRAND2_LIGHT_BARE_FOCUS,
    hover: BRAND2_LIGHT_BARE_HOVER,
    pressed: BRAND2_LIGHT_BARE_PRESSED
};
// Dark + Hard
export const BRAND2_DARK_HARD = {
    default: BRAND2_DARK_HARD_DEFAULT,
    disabled: BRAND2_DARK_HARD_DISABLED,
    focus: BRAND2_DARK_HARD_FOCUS,
    hover: BRAND2_DARK_HARD_HOVER,
    pressed: BRAND2_DARK_HARD_PRESSED
};
// Dark + White
export const BRAND2_DARK_WHITE = {
    default: BRAND2_DARK_WHITE_DEFAULT,
    disabled: BRAND2_DARK_WHITE_DISABLED,
    focus: BRAND2_DARK_WHITE_FOCUS,
    hover: BRAND2_DARK_WHITE_HOVER,
    pressed: BRAND2_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const BRAND2_DARK_GHOST = {
    default: BRAND2_DARK_GHOST_DEFAULT,
    disabled: BRAND2_DARK_GHOST_DISABLED,
    focus: BRAND2_DARK_GHOST_FOCUS,
    hover: BRAND2_DARK_GHOST_HOVER,
    pressed: BRAND2_DARK_GHOST_PRESSED
};
// Dark + Bare
export const BRAND2_DARK_BARE = {
    default: BRAND2_DARK_BARE_DEFAULT,
    disabled: BRAND2_DARK_BARE_DISABLED,
    focus: BRAND2_DARK_BARE_FOCUS,
    hover: BRAND2_DARK_BARE_HOVER,
    pressed: BRAND2_DARK_BARE_PRESSED
};
// Light
export const BRAND2_LIGHT = {
    bare: BRAND2_LIGHT_BARE,
    ghost: BRAND2_LIGHT_GHOST,
    hard: BRAND2_LIGHT_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND2_LIGHT_HARD,
    white: BRAND2_LIGHT_WHITE
};
// Dark
export const BRAND2_DARK = {
    bare: BRAND2_DARK_BARE,
    ghost: BRAND2_DARK_GHOST,
    hard: BRAND2_DARK_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND2_DARK_HARD,
    white: BRAND2_DARK_WHITE
};
// Color schema
const BRAND2 = {
    dark: BRAND2_DARK,
    light: BRAND2_LIGHT
};
export default BRAND2;
//# sourceMappingURL=palette.schema.brand2.js.map